import { Component, type ErrorInfo, type ReactNode } from 'react';
import { EstadoErro } from './ui/estados';

interface Props {
  children: ReactNode;
}

interface Estado {
  erro: Error | null;
}

/**
 * Último anteparo: uma exceção de render não pode deixar o operador com a
 * tela em branco no meio do turno.
 */
export class LimiteDeErro extends Component<Props, Estado> {
  override state: Estado = { erro: null };

  static getDerivedStateFromError(erro: Error): Estado {
    return { erro };
  }

  override componentDidCatch(erro: Error, info: ErrorInfo): void {
    console.error('Falha não tratada na interface', erro, info.componentStack);
  }

  override render(): ReactNode {
    if (this.state.erro) {
      return (
        <div className="flex h-full items-center justify-center bg-fundo">
          <EstadoErro
            erro={this.state.erro}
            aoTentarDeNovo={() => {
              this.setState({ erro: null });
              window.location.reload();
            }}
          />
        </div>
      );
    }
    return this.props.children;
  }
}
